import UpdateNoticeModalContainer from './UpdateNoticeModalContainer';

export default UpdateNoticeModalContainer;
